import axios from "axios";
import { get, isEmpty } from "lodash";
import { apiDetails } from "./helpers";
import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";

function createAPIInstance() {
  const tokenKey = window.localStorage.getItem(
    `${process.env.REACT_APP_CLIENTID}user:${process.env.REACT_APP_AUTHENTICATION_BASE_URL}:${process.env.REACT_APP_CLIENTID}`
  );
  let authToken = get(JSON.parse(tokenKey), "access_token");
  const tokenHeader = {
    Authorization: `Bearer ${authToken}`,
    mode: "no-cors",
  };

  const dateTransformer = (data) => {
    if (data instanceof Date) {
      // do your specific formatting here
      return data.toLocaleString("en-US");
    }
    if (Array.isArray(data)) {
      return data.map((val) => dateTransformer(val));
    }
    if (typeof data === "object" && data !== null && !isEmpty(data)) {
      return Object.fromEntries(
        Object.entries(data).map(([key, val]) => [key, dateTransformer(val)])
      );
    }
    return data;
  };

  const api = axios.create({
    baseURL: apiDetails.baseUrl.trim(),
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      ...tokenHeader,
    },
    transformRequest: [dateTransformer].concat(axios.defaults.transformRequest),
  });

  api.interceptors.response.use(
    (response) => {
      const errorResponse = get(response, "data.result.error", {});
      if (!isEmpty(errorResponse)) {
        throw errorResponse;
      }
      return response.data;
    },
    (error) => {
      if (error && error.response && error.response.status === 401) {
        window.location = ApplicationPaths.Login;
        return null;
      }
      return Promise.reject(error);
    }
  );
  return api;
}

export default createAPIInstance;
